/* Hero buy box. Swaps the photo when a colour is chosen, and keeps the link on
   the photo pointing at that same colour.

   The replacement image is preloaded before it is put on screen, so the frame
   never goes blank mid-swap; the aspect ratio travels with it so the column
   cannot jump if two colours were shot at different sizes. If this never runs,
   the radios still submit and the photo simply stays on the first colour. */
(function () {
  'use strict';

  function build(root) {
    if (root.dataset.moBound) return;
    root.dataset.moBound = '1';

    var store = root.querySelector('[data-mo-variants]');
    var img = root.querySelector('[data-mo-heroimg]');
    var fig = root.querySelector('[data-mo-fig]');
    var link = root.querySelector('[data-mo-herolink]');
    var priceEl = root.querySelector('[data-mo-price]');
    if (!store || !img) return;

    var map = {};
    try {
      var rows = JSON.parse(store.textContent);
      for (var i = 0; i < rows.length; i++) map[String(rows[i].id)] = rows[i];
    } catch (e) { return; }

    function swap(v) {
      if (!v.src || img.getAttribute('src') === v.src) return;
      var pre = new Image();
      img.classList.add('is-swapping');
      pre.onload = function () {
        if (fig && v.ratio) fig.style.aspectRatio = v.ratio;
        img.src = v.src;
        if (v.srcset) img.srcset = v.srcset;
        if (v.alt) img.alt = v.alt;
        img.classList.remove('is-swapping');
      };
      pre.onerror = function () { img.classList.remove('is-swapping'); };
      if (v.srcset) pre.srcset = v.srcset;
      pre.sizes = img.sizes || '';
      pre.src = v.src;
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || t.name !== 'id') return;
      var v = map[String(t.value)];
      if (!v) return;
      swap(v);
      if (priceEl && v.price) priceEl.textContent = v.price;
      if (link && v.url) link.href = v.url;
    });
  }

  function init() {
    document.querySelectorAll('[data-mo-hero]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
